import { render, staticRenderFns } from "./InsuranceBridgeTableList.vue?vue&type=template&id=9de664d4&scoped=true&"
import script from "./InsuranceBridgeTableList.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeTableList.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceBridgeTableList.vue?vue&type=style&index=0&id=9de664d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de664d4",
  null
  
)

export default component.exports